<script setup lang="ts">
  import { computed } from 'vue'
  const props = defineProps<{
    name: string
    width?: string
    height?: string
  }>()

  const src = computed(() => {
    return new URL(`../../assets/img/${props.name}.svg`, import.meta.url).href
  })
</script>

<template>
  <img :src="src" :alt="name" :width="width" :height="height" />
</template>
